import React, { type Node, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Banner,
  Box,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { useFetchHouseholdNotifications } from 'components/HouseholdNotifications/hooks';
import messages from './messages';

const handleNeedsReviewNotifications = (notifications: Array) => {
  // this is a bit weird since the requirement was to have a single banner for
  // all the needs reviews, oh well.
  if (notifications.length > 0) {
    return [
      <Banner
        key="needs-reviews-combined"
        status="warning"
        message={<FormattedMessage {...messages.needsReviewCombined} />}
      />,
    ];
  }
};

// Every notification type would need to implement a handler that will return
// an array of Banners... they would also need to deal with the key situation also.
const HANDLERS = {
  NEEDS_REVIEW: handleNeedsReviewNotifications,
};

const formatNotifications = (data) => {
  const notifications = [];
  const groupedByType = {};
  for (const notification of data ?? []) {
    if (!groupedByType[notification.type]) {
      groupedByType[notification.type] = [];
    }
    groupedByType[notification.type].push(notification);
  }

  for (const [key, value] of Object.entries(groupedByType)) {
    if (HANDLERS[key]) {
      notifications.push(...HANDLERS[key](value));
    }
  }

  return notifications;
};

const HouseholdNotifications = ({
  organizationId,
  propertyId,
  householdId,
}): Node => {
  const { data } = useFetchHouseholdNotifications(
    organizationId,
    propertyId,
    householdId,
  );
  const notifications = useMemo(() => {
    return formatNotifications(data);
  }, [data]);

  if (notifications.length > 0) {
    return <Box sx={{ pt: 2, ml: 2, mr: 2 }}>{notifications}</Box>;
  }
  return null;
};

export default HouseholdNotifications;
